/**
 * <s-whatsapp-link> — opens a WhatsApp chat directly, skipping the wa.me "Continue to chat" page.
 *
 * Phones and tablets open the WhatsApp app (whatsapp://), so the store stays open behind it.
 * Computers open WhatsApp Web in a new tab. The inner <a href="https://wa.me/…"> stays as
 * the no-JS fallback.
 *
 * Expected DOM (rendered by blocks/whatsapp-button.liquid):
 *   <s-whatsapp-link data-phone="923001234567" data-message="Hi!">
 *     <a href="https://wa.me/…" target="_blank">…</a>
 *   </s-whatsapp-link>
 */
class SWhatsappLink extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.link = this.querySelector("a");
    this.link?.addEventListener("click", (event) => this.open(event), { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  /** @param {MouseEvent} event */
  open(event) {
    const phone = this.dataset.phone;
    if (!phone) return;

    const params = new URLSearchParams({ phone });
    if (this.dataset.message) params.set("text", this.dataset.message);

    event.preventDefault();

    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;
    if (isTouchDevice) {
      // Hands off to the installed app; the browser tab with the store is left untouched.
      window.location.href = `whatsapp://send?${params}`;
      // If the app isn't installed nothing happens, so fall back to wa.me after a moment.
      const fallbackUrl = this.link?.href;
      window.setTimeout(() => {
        if (!document.hidden && fallbackUrl) window.location.href = fallbackUrl;
      }, 1500);
      return;
    }

    window.open(`https://web.whatsapp.com/send?${params}`, "_blank", "noopener");
  }
}

if (!customElements.get("s-whatsapp-link")) {
  customElements.define("s-whatsapp-link", SWhatsappLink);
}
